export interface Category {
  id: string;
  name: string;
  tagline: string;
  desc: string;
}

export interface Manhwa {
  id: string;
  title: string;
  author: string;
  category: string;
  score: number;
  status: '连载中' | '已完结';
  tags: string[];
  summary: string;
  cover: string;
  recommended: boolean;
  trending: boolean;
  hiddenGem: boolean;
  chapters: number;
}

export const categories: Category[] = [
  { id: 'urban', name: '都市日常', tagline: '现实向都市故事', desc: '发生在都市里的日常、职场与青春故事，贴近生活又带点巧思。' },
  { id: 'fantasy', name: '奇幻冒险', tagline: '异世界与魔法想象', desc: '异世界、魔法与宏大世界观，满足你对想象力的全部期待。' },
  { id: 'romance', name: '恋爱漫', tagline: '心动与怦然', desc: '从暗恋到热恋，各种口味的恋爱故事，甜度与酸涩并存。' },
  { id: 'action', name: '热血战斗', tagline: '燃爆的战斗漫画', desc: '拳拳到肉的战斗与成长，看主角一路逆袭登顶。' },
  { id: 'thriller', name: '悬疑惊悚', tagline: '反转与刺激', desc: '层层反转的悬疑与惊悚剧情，一追就停不下来。' },
  { id: 'rebirth', name: '穿越重生', tagline: '回到过去的逆袭', desc: '重生、穿越、系统，主角手握剧本一路开挂。' },
  { id: 'healing', name: '治愈暖萌', tagline: '温暖治愈系', desc: '治愈人心的温柔故事，看完心里暖暖的。' },
];

export const manhwaList: Manhwa[] = [
  {
    id: 'yeoshingangrim',
    title: '女神降临',
    author: 'Yaongyi',
    category: 'romance',
    score: 9.4,
    status: '已完结',
    tags: ['校园', '甜宠', '搞笑'],
    summary: '一个因为外貌饱受困扰的女孩，靠化妆开启完全不同的人生，却在校园里遇到了知道她秘密的男孩。轻松爆笑又甜到心坎的恋爱故事。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20illustration%20of%20a%20pretty%20school%20girl%20with%20natural%20makeup%20smiling%20among%20cherry%20blossoms%20and%20school%20campus%2C%20warm%20romance%20tone%2C%20soft%20cream%20background%2C%20stylized%20manga%20cover%20art%2C%20clean%20linework%2C%20vibrant%20but%20warm%20palette&width=600&height=800&seq=cover-01&orientation=portrait',
    recommended: true,
    trending: true,
    hiddenGem: false,
    chapters: 232,
  },
  {
    id: 'narobuteui',
    title: '我独自升级',
    author: 'Chugong',
    category: 'action',
    score: 9.6,
    status: '已完结',
    tags: ['系统', '升级', '战斗'],
    summary: '全球最弱的猎人E级，在一次副本中意外获得"只有他能升级"的神秘系统，从此踏上登顶最强之路。动作分镜堪称教科书级别。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20action%20cover%20art%20of%20a%20powerful%20young%20hunter%20with%20glowing%20purple%20system%20window%20and%20dark%20shadow%20magic%20behind%20him%2C%20dramatic%20epic%20mood%2C%20warm%20rim%20lighting%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-02&orientation=portrait',
    recommended: true,
    trending: true,
    hiddenGem: false,
    chapters: 179,
  },
  {
    id: 'jeonjijeog',
    title: '全知读者视角',
    author: 'singNsong',
    category: 'fantasy',
    score: 9.5,
    status: '连载中',
    tags: ['异世界', '生存', '智斗'],
    summary: '唯一读过小说结局的读者，眼睁睁看着小说里的末日降临现实。他只能靠对剧情的"全知"与冷门知识，在这场生存游戏里步步为营。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20of%20a%20boy%20holding%20a%20glowing%20book%20before%20an%20apocalyptic%20city%20collapse%2C%20mysterious%20blue%20beams%2C%20dramatic%20sky%2C%20warm%20contrast%20lighting%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-03&orientation=portrait',
    recommended: true,
    trending: true,
    hiddenGem: false,
    chapters: 220,
  },
  {
    id: 'sweet-home',
    title: '甜蜜家园',
    author: 'Kim Carnby',
    category: 'thriller',
    score: 9.2,
    status: '已完结',
    tags: ['末日', '怪物', '人性'],
    summary: '世界崩坏、怪物横行，一栋老旧公寓成了最后的堡垒。面对欲望化作的怪物，人与人之间的信任也一点点崩塌。压抑又上头的末日群像。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20horror%20cover%20of%20an%20old%20apartment%20building%20at%20night%20with%20shadowy%20monster%20silhouettes%2C%20tense%20apocalyptic%20mood%2C%20warm%20dim%20lighting%2C%20stylized%20manhwa%20illustration%2C%20gritty%20clean%20linework&width=600&height=800&seq=cover-04&orientation=portrait',
    recommended: false,
    trending: true,
    hiddenGem: false,
    chapters: 140,
  },
  {
    id: 'oegimo',
    title: '看脸时代',
    author: 'Park Tae-jun',
    category: 'urban',
    score: 8.9,
    status: '连载中',
    tags: ['校园', '格斗', '成长'],
    summary: '身材肥胖却长相清秀的少年，夜里会变成"帅哥"模样，过着两种截然不同的人生。校园暴力与自我认同交织的热血成长故事。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20urban%20cover%20of%20a%20young%20man%20in%20school%20uniform%20standing%20between%20day%20and%20night%20shadows%2C%20identity%20theme%2C%20warm%20city%20backdrop%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-05&orientation=portrait',
    recommended: false,
    trending: true,
    hiddenGem: false,
    chapters: 500,
  },
  {
    id: 'gangcheol',
    title: '热血校草',
    author: 'Jungtae',
    category: 'action',
    score: 8.7,
    status: '连载中',
    tags: ['校园', '逆袭', '打斗'],
    summary: '被全校欺凌的转学生，意外觉醒了"越挨打越强大"的天赋。从此从校园最底层一路打上顶点，够爽也够燃。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fight%20cover%20of%20a%20teenager%20in%20school%20uniform%20clenching%20fist%20with%20spark%20energy%20around%20his%20arms%2C%20dynamic%20pose%2C%20warm%20sunset%20school%20rooftop%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-06&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 380,
  },
  {
    id: 'loutwangja',
    title: '废柴皇子的逆袭',
    author: 'Yunna',
    category: 'rebirth',
    score: 8.8,
    status: '连载中',
    tags: ['穿越', '权谋', '系统'],
    summary: '穿越成注定被废黜的落魄皇子，凭借现代知识与系统金手指，在宫廷权谋里步步为营，改写必死的结局。爽感与智斗兼具。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20of%20a%20young%20prince%20in%20royal%20robes%20with%20a%20glowing%20golden%20system%20interface%2C%20royal%20palace%20throne%20hall%20behind%2C%20warm%20amber%20lighting%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-07&orientation=portrait',
    recommended: true,
    trending: false,
    hiddenGem: false,
    chapters: 168,
  },
  {
    id: 'doseonsa',
    title: '道山四',
    author: 'Seokwoo',
    category: 'thriller',
    score: 8.6,
    status: '连载中',
    tags: ['悬疑', '都市传说', '猎奇'],
    summary: '传闻中的废弃公寓"道山四"住着一群不请自来的"住客"。新搬来的主角逐渐发现，这里的住户似乎都不太像"人"。都市恐怖爱好者的心头好。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20mystery%20cover%20of%20an%20old%20abandoned%20apartment%20corridor%20with%20a%20single%20door%20slightly%20open%20casting%20warm%20light%2C%20eerie%20atmosphere%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-08&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 96,
  },
  {
    id: 'seonbae',
    title: '前辈请别这样',
    author: 'Hana',
    category: 'romance',
    score: 8.9,
    status: '已完结',
    tags: ['职场', '甜宠', '欢喜冤家'],
    summary: '冷静克制的职场前辈，遇上一个元气满满的后辈实习生。从互相看不顺眼到慢慢沦陷，细腻又心动的办公室恋爱。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20of%20a%20cute%20office%20woman%20and%20a%20serious%20male%20colleague%20at%20a%20sunlit%20modern%20office%20window%2C%20soft%20warm%20tones%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-09&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 120,
  },
  {
    id: 'moogong',
    title: '武神之路',
    author: 'Kim Jae-hwan',
    category: 'action',
    score: 9.0,
    status: '连载中',
    tags: ['武侠', '武道', '热血'],
    summary: '身负血海深仇的少年踏入江湖，从无名小卒一步步踏上武神之巅。拳拳到肉的江湖快意，招式与心境共同成长。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20wuxia%20cover%20of%20a%20young%20martial%20artist%20in%20flowing%20robes%20mid%20powerful%20punch%20with%20energy%20wave%2C%20misty%20mountains%20and%20pagoda%20behind%2C%20warm%20sunrise%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-10&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 260,
  },
  {
    id: 'gwichok',
    title: '归巢',
    author: 'Soonyoung',
    category: 'healing',
    score: 8.8,
    status: '已完结',
    tags: ['家庭', '温情', '成长'],
    summary: '离家多年的女孩回到海边小镇，重新学会与家人相处，也在渔港的日常里找回了自己的热爱。温柔细腻的治愈系佳作。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20healing%20cover%20of%20a%20girl%20walking%20on%20a%20sunset%20seaside%20pier%20with%20fishing%20boats%20and%20seagulls%2C%20warm%20golden%20tones%2C%20stylized%20manhwa%20illustration%2C%20soft%20clean%20linework&width=600&height=800&seq=cover-11&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 88,
  },
  {
    id: 'mabeopsa',
    title: '最强魔法师的新手村生活',
    author: 'Dohwan',
    category: 'fantasy',
    score: 8.9,
    status: '连载中',
    tags: ['魔法', '搞笑', '无敌流'],
    summary: '退休的传奇魔法师回到新手村养老，却总被各种各样的麻烦找上门。轻松爆笑的无敌流，看着就开心。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20of%20a%20wizard%20in%20a%20cozy%20village%20with%20sparkling%20magic%20circles%20and%20cute%20monsters%2C%20playful%20lighthearted%20mood%2C%20warm%20pastel%20palette%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-12&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 150,
  },
  {
    id: 'jigae',
    title: '泡面与恋爱',
    author: 'Mimi',
    category: 'romance',
    score: 8.6,
    status: '连载中',
    tags: ['美食', '日常', '轻松'],
    summary: '深夜便利店，两个吃泡面的陌生人因为口味争执而相识。从一碗泡面开始的心动日常，又暖又治愈又有点甜。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20of%20a%20young%20couple%20sharing%20noodles%20at%20a%20cozy%20convenience%20store%20at%20night%2C%20warm%20streetlight%20glow%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-13&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 76,
  },
  {
    id: 'yuhon',
    title: '魂之少年',
    author: 'Baekho',
    category: 'action',
    score: 8.5,
    status: '连载中',
    tags: ['除灵', '热血', '灵异'],
    summary: '能看见鬼魂的少年，加入阴阳师社团，在一次次的除灵任务里直面自己的过去。热血与灵异结合的独特题材。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20boy%20holding%20a%20luminous%20talisman%20with%20ghostly%20spirits%20swirling%20around%2C%20dark%20temple%20night%20scene%20with%20warm%20fire%20light%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-14&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 210,
  },
  {
    id: 'mirae',
    title: '重返小学时代',
    author: 'Jungyeon',
    category: 'rebirth',
    score: 8.9,
    status: '连载中',
    tags: ['重生', '校园', '热血'],
    summary: '人到中年的落魄大叔重生回小学，带着成年人的心智重新活一次。这一次他要守护家人、赢回尊严，也给小时候的自己一个交代。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20rebirth%20cover%20of%20an%20adult%20spirit%20in%20a%20kids%20school%20classroom%20with%20sunlight%20and%20chalkboard%2C%20nostalgic%20warm%20tones%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-15&orientation=portrait',
    recommended: true,
    trending: false,
    hiddenGem: false,
    chapters: 180,
  },
  {
    id: 'baem',
    title: '蛇王子',
    author: 'Kirin',
    category: 'fantasy',
    score: 8.7,
    status: '已完结',
    tags: ['人外', '宫廷', '奇幻'],
    summary: '被诅咒成蛇形的王子，与误入王宫的少女立下契约。一场关于诅咒、救赎与爱的奇幻旅程，画风华丽又唯美。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20fantasy%20cover%20of%20an%20elegant%20serpent%20prince%20in%20royal%20robes%20with%20jade%20eyes%20in%20a%20moonlit%20royal%20garden%2C%20ethereal%20warm%20moonlight%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-16&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 145,
  },
  {
    id: 'seomgang',
    title: '小岛日常',
    author: 'Haein',
    category: 'healing',
    score: 9.0,
    status: '已完结',
    tags: ['治愈', '日常', '慢生活'],
    summary: '辞职搬去海岛小城的年轻女生，在开面包店的日常里，和温暖的邻居们慢慢治愈了疲惫的自己。治愈系天花板级别的作品。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20healing%20cover%20of%20a%20young%20woman%20baking%20bread%20in%20a%20cozy%20seaside%20bakery%20with%20warm%20sunlight%20and%20ocean%20view%20window%2C%20gentle%20pastel%20warm%20tones%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-17&orientation=portrait',
    recommended: true,
    trending: false,
    hiddenGem: false,
    chapters: 132,
  },
  {
    id: 'bugdeul',
    title: '悬案调查组',
    author: 'Taeseok',
    category: 'thriller',
    score: 8.9,
    status: '连载中',
    tags: ['刑侦', '悬疑', '单元剧'],
    summary: '一支专办悬案的调查小组，在一次次冷案重启里逼近真相。每一案都反转十足，烧脑又过瘾。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20crime%20mystery%20cover%20of%20a%20detective%20team%20in%20a%20dim%20evidence%20room%20with%20case%20files%20and%20warm%20desk%20lamp%2C%20tense%20atmosphere%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-18&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 110,
  },
  {
    id: 'salam',
    title: '春日将至',
    author: 'Narae',
    category: 'urban',
    score: 8.8,
    status: '连载中',
    tags: ['青春', '成长', '写实'],
    summary: '四个即将毕业的高中生，在最后一个春天里面对迷茫、友情与选择。细腻写实的青春群像，看哭不少人。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20youth%20cover%20of%20four%20high%20school%20friends%20walking%20through%20cherry%20blossom%20spring%20streets%2C%20warm%20soft%20tones%2C%20nostalgic%20mood%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-19&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 98,
  },
  {
    id: 'wangbi',
    title: '王妃逆袭记',
    author: 'Darae',
    category: 'rebirth',
    score: 8.7,
    status: '连载中',
    tags: ['重生', '宫斗', '权谋'],
    summary: '被陷害而死的王妃重生回大婚当日，这一次她要避开所有陷阱，夺回属于自己的一切。宅斗权谋爱好者必看。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20rebirth%20cover%20of%20an%20elegant%20korean%20palace%20queen%20in%20hanbok%20with%20determined%20expression%20in%20a%20golden%20throne%20hall%2C%20warm%20royal%20lighting%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-20&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 170,
  },
  {
    id: 'geumul',
    title: '隐秘之网',
    author: 'Jungho',
    category: 'thriller',
    score: 9.1,
    status: '连载中',
    tags: ['推理', '黑深残', '反转'],
    summary: '一桩看似普通的失踪案，牵出一张盘根错节的隐秘网络。主角在追查真相的过程中，发现自己早已身处网中央。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20thriller%20cover%20of%20a%20mysterious%20figure%20standing%20in%20a%20spiderweb%20of%20strings%20and%20city%20lights%20at%20night%2C%20tense%20mood%2C%20warm%20neon%20accents%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-21&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: true,
    chapters: 88,
  },
  {
    id: 'gocha',
    title: '功夫小厨',
    author: 'Seoyun',
    category: 'urban',
    score: 8.6,
    status: '连载中',
    tags: ['美食', '温情', '日常'],
    summary: '在巷口开小饭馆的功夫高手，白天颠勺做菜，晚上伸张正义。每一集都有一道治愈人心的美食，温暖又下饭。',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cover%20of%20a%20chef%20in%20apron%20tossing%20wok%20flame%20in%20a%20cozy%20street%20restaurant%20kitchen%2C%20warm%20steam%20and%20golden%20light%2C%20stylized%20manhwa%20illustration%2C%20clean%20linework&width=600&height=800&seq=cover-22&orientation=portrait',
    recommended: false,
    trending: false,
    hiddenGem: false,
    chapters: 125,
  },
];

export const site = {
  name: '漫卷书单',
  brand: '漫卷书单',
  slogan: '好看的韩漫推荐，追更不迷路',
  email: 'hello@manjuanshudan.com',
  since: '2023',
};